import * as yup from 'yup';
import useTranslation from '../../../Hooks/useTranslation';
import {
	conditionalStringOneOfValidation,
	phoneNumberOrEmailValidation,
} from '../Helpers/patientRegistration.helper';
export default function usePatientManualRegistrationPolandFormValidationScheme(
	isChild: boolean,
) {
	const { t } = useTranslation();

	const validationSchema = yup
		.object({
			pesel: yup
				.string()
				.min(
					11,
					t('validation.patientManualRegistrationPolandForm.peselLength'),
				)
				.max(
					11,
					t('validation.patientManualRegistrationPolandForm.peselLength'),
				)
				.required(t('validation.patientManualRegistrationPolandForm.pesel')),
			salutationBefore: yup.string().notRequired().nullable(),
			salutationAfter: yup.string().notRequired().nullable(),
			firstName: yup
				.string()
				.required(t('validation.patientManualRegistrationCzechForm.firstName')),
			lastName: yup
				.string()
				.required(t('validation.patientManualRegistrationCzechForm.lastName')),
			address: yup.object().shape({
				street: yup
					.string()
					.required(
						t('validation.patientManualRegistrationCzechForm.address.street'),
					),
				descriptiveNumber: yup
					.string()
					.required(
						t(
							'validation.patientManualRegistrationCzechForm.address.descriptiveNumber',
						),
					),
				guideNumber: yup.string().notRequired().nullable(),
				city: yup
					.string()
					.required(
						t('validation.patientManualRegistrationCzechForm.address.city'),
					),
				postCode: yup
					.string()
					.required(
						t('validation.patientManualRegistrationCzechForm.address.postCode'),
					),
			}),
			healthInsuranceCompany: yup.mixed().notRequired().nullable(),
			citizenship: yup
				.mixed()
				.required(
					t('validation.patientManualRegistrationCzechForm.citizenship'),
				),
			phoneNumber: yup
				.string()
				.nullable()
				.test(
					'phone-required',
					t('validation.patientManualRegistrationCzechForm.phoneNumber'),
					function (value) {
						return conditionalStringOneOfValidation(
							isChild,
							value,
							this.parent.email,
						);
					},
				),
			email: yup
				.string()
				.email(t('validation.patientManualRegistrationCzechForm.email'))
				.nullable()
				.test(
					'email-required',
					t('validation.patientManualRegistrationCzechForm.email'),
					function (value) {
						return conditionalStringOneOfValidation(
							isChild,
							value,
							this.parent.phoneNumber,
						);
					},
				),
			healthPlanCode: yup.mixed().notRequired().nullable(),
			healthPlanWorkplaceMember: yup.mixed().notRequired().nullable(),
			legalRepresentative: isChild
				? yup.object().shape({
						firstName: yup
							.string()
							.required(
								t(
									'validation.patientManualRegistrationCzechForm.legalRepresentative.firstName',
								),
							),
						lastName: yup
							.string()
							.required(
								t(
									'validation.patientManualRegistrationCzechForm.legalRepresentative.lastName',
								),
							),
						email: yup
							.string()
							.email(t('validation.patientManualRegistrationCzechForm.email'))
							.required(
								t(
									'validation.patientManualRegistrationCzechForm.legalRepresentative.email',
								),
							),
						phoneNumber: yup.string().notRequired().nullable(),
				  })
				: yup.mixed().notRequired().nullable(),
			createdByType: yup
				.object({
					value: yup
						.string()
						.required(
							t('validation.patientManualRegistrationCzechForm.createdByType'),
						),
					label: yup.string(),
				})
				.required(),
			createdById: yup.mixed().when('createdByType.value', {
				is: 'USER',
				then: yup
					.mixed()
					.required(
						t('validation.patientManualRegistrationCzechForm.createdById'),
					),
				otherwise: yup.mixed(),
			}),
		})
		.test(
			'phone-or-email',
			t('validation.patientManualRegistrationCzechForm.phoneOrEmailRequired'),
			value => phoneNumberOrEmailValidation(isChild, value),
		);

	return { validationSchema };
}
